export function when<K extends object, Value extends keyof K>(record: K, value: Value): K[Value];
export function when<K extends object, T>(record: K, value: string | number, fallback: T): K[keyof K] | T;

/**
 * record와 record key를 받아 맵핑된 데이터를 가져옵니다.
 */
export function when<K extends object, Value extends keyof K, T>(record: K | Partial<K>, value: Value, fallback?: T) {
  if (fallback == null) {
    return record[value];
  }

  return record[value] ?? fallback;
}
